export default __webpack_public_path__ + "static/social-acerca-7c6b2771cf36663e38b2a1bd63589ab1.png";